import formatString from 'format-string-by-pattern';

const date = (value: string) => {
  let result = '';
  if (value) {
    const onlyNumbers = value.replace(/[^\d]/g, '');
    result = formatString('99/99/9999', onlyNumbers);
  }
  return result;
};

const cardNumber = (value: string) => {
  let result = '';
  if (value) {
    const onlyNumbers = value.replace(/[^\d]/g, '');
    result = formatString('9999 9999 9999 9999', onlyNumbers);
  }
  return result;
}
const cardDate = (value: string) => {
  let result = '';
  if (value) {
    const onlyNumbers = value.replace(/[^\d]/g, '');
    result = formatString('99', onlyNumbers);
  }
  return result;
};

const cardExpDate = (value: string) => {
  let result = '';
  if (value) {
    if (parseInt(value.replace(/[^\d]/g, '')) == 0) value = '0'
    if (value.slice(0, 2) && parseInt(value.slice(0, 2)) > 12) {
      value = `0${value}`
    }
    const onlyNumbers = value.replace(/[^\d]/g, '');
    result = formatString('99 / 99', onlyNumbers);
  }
  return result;
};

const cvc = (value: string) => {
  let result = '';
  if (value) {
    const onlyNumbers = value.replace(/[^\d]/g, '');
    result = formatString('9999', onlyNumbers);
  }
  return result;
};

const ssn = (value: string) => {
  let result = '';
  if (value) {
    const onlyNumbers = value.replace(/[^\d]/g, '');
    result = formatString('999-99-9999', onlyNumbers);
  }
  return result;
};

const phone = (value: string) => {
  let result = '';
  if (value) {
    const onlyNumbers = value.replace(/[^\d]/g, '');
    result = formatString('9-999-999-9999', onlyNumbers);
  }
  return result;
}

const initials = (value: string) => {
  let result = '';
  if (value) {
    result = value.replace(/[\d]/g, '');
  }
  return result;
}
const number = (value: string) => {
  if (value) {
    return value.replace(/[\D]/g, '');
  }
  return value;
}
const requestId = (value: string) => {
  if (value) {
    return value.replace(/[^\d-]/g, '');
  }
  return value;
}
const dateInput = (value: string) => {
  if (value) {
    let [m, d, y] = value.split('/').filter(i => i)

    let dSlash = value.split('').filter(i => i == '/').length >= 1
    let ySlash = value.split('').filter(i => i == '/').length >= 2

    if (parseInt(m) > 12 || m?.length > 2) {
      d = m[m.length == 3 ? 2 : 1]
      m = m.slice(0, m.length == 3 ? 2 : 1)
      dSlash = true
    }
    if (parseInt(d) > 31 || d?.length > 2) {
      y = d[d.length == 3 ? 2 : 1]
      d = d.slice(0, d.length == 3 ? 2 : 1)
      ySlash = true
    }
    let result = `${m || ''}${dSlash ? '/' : ''}${d || ''}${ySlash ? '/' : ''}${y || ''}`
    return result
  } else return ''
}
const notNumber = (value: string) => {
  if (value) {
    return value.replace(/[\d]/g, '');
  }
  return value;
}

const snakeCaseToTitleCase = (input: string) => {
  // Split the input string into an array of words
  const words = input.split('_');

  // Capitalize the first letter of each word and join them with spaces
  const titleCaseWords = words.map(word => {
    // Capitalize the first letter of the word and make the rest lowercase
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  });

  // Join the title case words with spaces to form the final title case string
  const titleCaseString = titleCaseWords.join(' ');

  return titleCaseString;
}

export const Parsers = {
  initials,
  date,
  ssn,
  cardNumber,
  cardExpDate,
  cardDate,
  cvc,
  phone,
  number,
  requestId,
  dateInput,
  notNumber,
  snakeCaseToTitleCase
};
